import React from "react";
import CodeBlock from "./CodeBlock";

const ResponseExample = ({ responses }) => {
  if (!responses || responses.length === 0) return null;

  return (
    <div className="api-docs-responses">
      <h3>Responses</h3>
      {responses.map((response, index) => (
        <div key={index} className="api-docs-response">
          <div className="api-docs-response-header">
            <span
              className={`api-docs-response-status ${
                response.status >= 200 && response.status < 300
                  ? "api-docs-response-status--success"
                  : "api-docs-response-status--error"
              }`}
            >
              {response.status}
            </span>
            <span className="api-docs-response-description">{response.description}</span>
          </div>
          {response.example && (
            <CodeBlock
              code={JSON.stringify(response.example, null, 2)}
              language="json"
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ResponseExample;
